jQuery(document).ready(function () {
  var $ = jQuery;
  // piilotetaan lomakkeiden label silloin kun placeholder on näkyvissä
  var input_containers = $(".gfield input, .gfield textarea").parent();

  input_containers.each(function (i, o) {
    var input = $(o).find("input, textarea");
    var label = $(o).find("label");

    if (label.length) {
      var required =
        input.attr("aria-required") && label.text().indexOf("*") == -1
          ? "*"
          : "";

      input
        .addClass("placeholder-shown")
        .attr("placeholder", label.text() + required);

      input.on("input", function () {
        if (input.val()) input.removeClass("placeholder-shown");
        else input.addClass("placeholder-shown");
      });
    }
  });
});
